import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUserContext } from './UserContext';


const PrivateRoute = () => {
  const { loginUser } = useUserContext();

  return loginUser ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
